import { useContext } from 'react';
import { AppCallActionsContext } from './app-call-actions-provider';

export const useAppCallActions = () => {
  const context = useContext(AppCallActionsContext);

  if (!context) {
    throw new Error('AppCallActions must be used within an AppCallActionsProvider');
  }

  return context;
};
